"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledList = void 0;
var _List = require("./List");
// TODO: in v9, move styled() from List.jsx to here
var StyledList = _List.List;
exports.StyledList = StyledList;